module.exports = __webpack_public_path__ + "img/icon_question_05.e0229c66.svg";